(function () {
  var el = document.getElementById('wistroIntro');
  var root = document.documentElement;

  function reveal() {
    root.classList.add('wisty-revealed');
  }

  if (!el) {
    reveal();
    return;
  }

  if (sessionStorage.getItem('wistyIntroShown')) {
    el.remove();
    reveal();
    return;
  }
  sessionStorage.setItem('wistyIntroShown', '1');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HOLD = reduced ? 200 : 450;
  var FADE = reduced ? 150 : 250;

  document.body.classList.add('wistro-lock');

  setTimeout(function () {
    el.classList.add('wistro--hidden');
    reveal();
    document.body.classList.remove('wistro-lock');
    setTimeout(function () { el.remove(); }, FADE);
  }, HOLD);
})();